var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "m12.5 4.17-7.2 7.19a7 7 0 0 0-.8.88c-.15.21-.27.44-.37.69-.1.27-.16.56-.28 1.15l-.52 2.59 2.59-.52c.59-.12.88-.18 1.15-.28.25-.1.48-.22.7-.37.24-.17.45-.38.87-.8l7.2-7.2s-1.67 0-2.5-.83c-.84-.84-.84-2.5-.84-2.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.54 3.09c.29-.14.63-.14.92 0 .13.06.27.2.76.69.5.49.63.63.69.76.14.29.14.63 0 .92-.06.13-.2.27-.69.76l-.63.64a2.7 2.7 0 0 1-2.45-2.45l.64-.63c.49-.5.63-.63.76-.69Zm-2.45 2.37L5.75 11.8c-.44.44-.6.6-.73.8a2.7 2.7 0 0 0-.3.55 5.8 5.8 0 0 0-.26 1.06l-.33 1.66 1.66-.33a5.8 5.8 0 0 0 1.06-.26c.2-.07.38-.17.56-.3.18-.13.35-.3.79-.73l6.34-6.34a3.97 3.97 0 0 1-2.45-2.45Zm3.93-3.49a2.3 2.3 0 0 0-2.04 0c-.34.17-.63.47-1.02.85l-.07.07-8.02 8.03-.04.04c-.39.38-.64.63-.84.92-.18.25-.32.53-.44.82-.13.32-.2.67-.3 1.2l-.01.06-.52 2.58a.62.62 0 0 0 .74.74l2.58-.52h.05c.54-.12.89-.18 1.21-.31.3-.12.57-.26.82-.44.29-.2.54-.45.92-.84l.04-.04 8.03-8.02.07-.07c.38-.39.68-.68.85-1.02a2.3 2.3 0 0 0 0-2.04 4.25 4.25 0 0 0-.85-1.02l-.07-.07-.07-.07c-.39-.38-.68-.68-1.02-.85Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.27dadd572b6af39d65410e7bde0059d2.svg";
export { ForwardRef as ReactComponent };